import {useCustomQuery} from "~/query/queryClient";
import {queryHttp} from "~/query/queryHttp";
import {buQualificationKpiSummaryUrl} from "~/pages/supplier-360/services/supplier360Urls";
import type {BuQualificationKpiSummary} from "~/pages/supplier-360/types/Supplier360Types";

/**
 * The Business units view's KPI strip (`GET supplier_360/bu_qualification/kpi_summary/?entity=`,
 * §2.7) — BU qualifications counted by `status`. A plain aggregate, the response is the object itself.
 */
export function useBuQualificationKpiSummaryQuery(entityId: number | undefined) {
    const url = buQualificationKpiSummaryUrl(entityId ?? 0);
    return useCustomQuery({
        queryKey: [url] as const,
        queryFn: async () => (await queryHttp.get<BuQualificationKpiSummary>(url)).data,
        enabled: Boolean(entityId),
    });
}
